import { Container, Divider, Stack, Typography } from '@mui/material'
import ListSubheader from '@mui/material/ListSubheader'
import MenuItem from '@mui/material/MenuItem'
import { FC } from 'react'
import { Tag } from 'ui-components/types/__generated/gql/graphql'

export type CategoryMapsProps<T> = {
  primaryTags: Tag[] | []
  secondaryTags: Tag[] | []
  slots: {
    MapsGrid: FC
  }
  onPrimaryTagClick: (tag: Tag) => void
  onSecondaryTagClick: (tag: Tag) => void
  onClearFilters: () => void
}

export const CategoryMaps = <T,>({
  primaryTags,
  secondaryTags,
  slots,
  onPrimaryTagClick,
  onSecondaryTagClick,
  onClearFilters
}: CategoryMapsProps<T>) => {
  return (
    <Container maxWidth={false}>
      <Stack
        direction='row'
        spacing={4}
      >
        <Stack
          spacing={2}
          sx={{ width: 300, pt: 2 }}
        >
          <ListSubheader sx={{ bgcolor: 'transparent' }}>
            <Typography
              variant='body1'
              fontWeight={'bold'}
              color={'text.primary'}
            >
              Use Cases
            </Typography>
          </ListSubheader>
          {primaryTags.map((tag) => (
            <MenuItem
              onClick={() => {
                onPrimaryTagClick(tag)
              }}
              key={tag.id}
              value={tag.id}
            >
              {tag.name}
            </MenuItem>
          ))}
          <ListSubheader sx={{ bgcolor: 'transparent' }}>
            <Typography
              variant='body1'
              fontWeight={'bold'}
              color={'text.primary'}
            >
              Topics
            </Typography>
          </ListSubheader>
          {secondaryTags.map((tag) => (
            <MenuItem
              onClick={() => {
                onSecondaryTagClick(tag)
              }}
              key={tag.id}
              value={tag.id}
            >
              {tag.name}
            </MenuItem>
          ))}
          <Divider sx={{ color: 'text.primary' }} />
          <MenuItem
            sx={{
              marginTop: '0 !important'
            }}
            onClick={() => {
              onClearFilters()
            }}
            key={'clear-filters'}
            value={'all'}
          >
            Clear filters
          </MenuItem>
        </Stack>
        {slots.MapsGrid && <slots.MapsGrid />}
      </Stack>
    </Container>
  )
}
